import {FC} from 'react'

const Tooltip: FC<{
    tooltiptext: string
}> = ({tooltiptext}) => {
    return <span className="tooltiptext">{tooltiptext}</span>
}

export default Tooltip
